import React from "react";
import { useNavigate } from "react-router-dom";

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <div className="bg-black border-b border-gray-800">
        <div className="container mx-auto px-6 py-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-300 hover:text-red-500 transition-colors duration-200"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="bg-gray-800 rounded-lg p-8 shadow-lg">
          <h1 className="text-4xl font-bold text-center mb-8 text-red-500">
            Terms of Service
          </h1>
          
          <div className="space-y-6 text-gray-300">
            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">1. Acceptance of Terms</h2>
              <p className="leading-relaxed">
                By accessing and using DESAC TV ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">2. Description of Service</h2>
              <p className="leading-relaxed">
                DESAC TV provides streaming content including sports, news, lifestyle programming, game shows, and other entertainment content. The Service is operated by Dynasty Sounds and Creations.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">3. User Accounts</h2>
              <p className="leading-relaxed">
                To access certain features of the Service, you must create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">4. Subscription and Payment</h2>
              <p className="leading-relaxed">
                The Service offers various subscription plans. By subscribing, you agree to pay the applicable fees. All payments are non-refundable unless otherwise stated. We reserve the right to modify subscription fees with 30 days notice.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">5. Acceptable Use</h2>
              <p className="leading-relaxed">
                You agree not to use the Service to:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Transmit harmful, offensive, or inappropriate content</li>
                <li>Attempt to gain unauthorized access to the Service</li>
                <li>Interfere with the proper functioning of the Service</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">6. Content and Intellectual Property</h2>
              <p className="leading-relaxed">
                All content on DESAC TV is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without explicit permission.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">7. Privacy</h2>
              <p className="leading-relaxed">
                Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">8. Termination</h2>
              <p className="leading-relaxed">
                We may terminate or suspend your account and access to the Service at any time, with or without cause, with or without notice. You may cancel your subscription at any time through your account settings.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">9. Disclaimers</h2>
              <p className="leading-relaxed">
                The Service is provided "as is" without warranties of any kind. We do not guarantee uninterrupted access to the Service or that the content will be error-free.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">10. Limitation of Liability</h2>
              <p className="leading-relaxed">
                In no event shall DESAC TV be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the Service.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">11. Changes to Terms</h2>
              <p className="leading-relaxed">
                We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service. Continued use of the Service after changes constitutes acceptance of the new terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold mb-4 text-white">12. Contact Information</h2>
              <p className="leading-relaxed">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <div className="mt-2 p-4 bg-gray-700 rounded">
                <p>Email: dynastyempire28@gmail.com</p>
                {/* <p>Phone: +260 xxx xxx xxx</p> */}
              </div>
            </div>

            <div className="mt-8 p-4 bg-gray-700 rounded">
              <p className="text-sm text-gray-400">
                <strong>Last updated:</strong> {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 